import { Typography } from '@mui/material';

import { AccessRequestClientModel } from '@client-app-sdk/api/v1';
import { DateTime } from '@common/utils/datetime';

export default function CreationTimeCell({ creation_time }: Pick<AccessRequestClientModel, 'creation_time'>) {
  return <Typography variant="body2">{DateTime.fromUnix(Number(creation_time)).readable}</Typography>;
}
